import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import SheetAttributeManager from 'services/sheet-attribute-manager/SheetAttributeManager';
import { AttributeMapperStore } from './types';

const useAttributeMapperStore = create<AttributeMapperStore>()(
  devtools(
    (set, get) => ({
      attributeMapperManager: new SheetAttributeManager({
        data: {},
        sheetIndicatorMapping: [],
      }),
      getAttributeMapperManager: () => get().attributeMapperManager,
      setAttributeMapperManager: manager => set(() => ({ attributeMapperManager: manager })),
      clearAttributeMapperManager: () => set(() => ({ attributeMapperManager: undefined })),
    }),
    {
      name: 'AttributeMapperStore',
    }
  )
);

export default useAttributeMapperStore;
